import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
        gap: '16px',
      }}
    >
      <Logo size="lg" />
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: '64px',
          fontWeight: 800,
          color: 'var(--ik-teal-light)',
          letterSpacing: '-1px',
          marginTop: '12px',
        }}
      >
        404
      </h1>
      <p style={{ color: 'var(--ik-gray-600)', maxWidth: '360px', lineHeight: 1.5 }}>
        La página que buscas no existe o fue movida.
      </p>
      <button
        className="ik-btn ik-btn--primary"
        onClick={() => navigate('/')}
        style={{ marginTop: '12px' }}
      >
        Volver al inicio
      </button>
    </div>
  );
}
